// extracted by mini-css-extract-plugin
export default {"calculate_btn":"calculationBtn_calculate_btn__PZ3aZ"};